<template>
  <div class="ContactPage">
    <div v-if="isLoading">
      <PreLoad />
    </div>
    <div v-else class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
          <img src="../../assets/contact.jpg" class="w" alt="فروشگاه نورا">
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3 flx" dir="rtl">
          <div class="desc mb-0">
            <h3 class="mb-3" style="text-align: right;"><span style="font-size: 14pt;">ارتباط با نورا&nbsp;</span></h3>
            <p style="text-align: right;"><span style="font-size: 14pt;"><span style="font-size: medium;">شماره تماس : <a title="تماس" href="tel:02144492773">02144492773</a></span></span></p>
            <p style="text-align: right;"><span style="font-size: 14pt;"><span style="font-size: medium;">واتساپ :&nbsp;</span><a style="font-size: medium;" title="whats app" href="whatsapp://send?phone=+989384431548">09384431548</a></span></p>
            <p style="text-align: right;">اینستاگرام نورا دیپ : <a href="https://www.instagram.com/nuorawatch.ir/">nuorawatch.ir</a></p>
            <p style="text-align: right;">ایمیل : <a href="mailto:info@nuorashop.ir">info@nuorashop.ir</a></p>
            <p style="text-align: right;">کد پستی : 1473189687</p>
          </div>
        </div>
      </div>
      <hr class="mb-5" />
      <div class="row mb-5" dir="rtl">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
          <h3 class="text-center">درخواست خود را در صورت نیاز به ما اعلام کنید</h3>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
          <input type="tel" class="form-control text-end" placeholder="شماره تماس" v-model="phone">
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
          <input type="text" class="form-control" placeholder="نام و نام خانوادگی" v-model="name">
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
          <textarea class="form-control" placeholder="متن پیام" v-model="text"></textarea>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3 text-center">
          <button aria-label="اعمال" type="submit" class="btn btn-secondary" :disabled="!text || !name || phone.length !== 11 " @click="sendData()">ارسال</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PreLoad from '@/components/PreLoad.vue'

export default {
  name: 'ContactPage',
  components: {
    PreLoad
  },
  data () {
    return {
      phone: this.$User ? this.$User.username : '',
      name: this.$User ? this.$User.name : '',
      text: '',
      isLoading: true
    }
  },
  methods: {
    sendData: function () {
      const mutation = `
      mutation msg {
        msg(phone: "${this.phone}", text: "${this.text}", name:"${this.name}") {
          status
        }
      }
      `
      this.$fetchGraphQL(mutation)
        .then(res => {
          if (res.data.msg.status === 'success') {
            this.text = ''
            this.fire({
              icon: 'success',
              title: 'ثبت شد',
              showConfirmButton: false,
              timer: 2000
            })
          } else {
            this.fire({
              icon: 'error',
              title: 'شماره تماس را به صورت صحیح وارد کنید',
              showConfirmButton: false,
              timer: 2000
            })
          }
        })
    }
  },
  mounted () {
    const query = `
    {
      meta(key:"${this.$options.name}") {
        seoTitle
        seoKeyword
        seoDescription
      }
    }
    `
    this.$fetchGraphQL(query).then(res => {
      this.setMetaByObj(res.data.meta)
      this.isLoading = false
    })
  }
}
</script>

<style scoped>
button{
  width: min-content;
}
.w{
  width: -moz-available;
  width: -webkit-fill-available;
  margin: 2rem;
}
.flx{
  display: flex;
  flex-direction: column;
  justify-content: center;
}
p {
  color:rgba(0,0,0,.55);
}
h1 {
  font-size:17pt;
}
h2 {
  font-size:15pt;
}
h3 {
  font-size:13pt;
}
</style>
